import React, { FC } from "react";
import { X } from "lucide-react";
import "./demomodel.css";

interface DemoModalProps {
  demolink: string;
  videoId: string; // YouTube video ID
  onClose: () => void;
}

const DemoModal: FC<DemoModalProps> = ({ demolink, videoId, onClose }) => {
  // Add autoplay=1, loop=1, and playlist=VIDEO_ID for auto-replay
  const autoplayLink = `${demolink}&autoplay=1&mute=1`;

  return (
    <div className="modal-overlay">
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button className="demo-close-button" onClick={onClose}>
          <X strokeWidth={2.2}></X>
        </button>
        <iframe
          width="100%"
          height="100%"
          src={autoplayLink}
          frameBorder="0"
          allow="autoplay; fullscreen; encrypted-media; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default DemoModal;
